import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.reason = bracketIndenting()
